<template>
  <div>
    <div id="testimonials-title">
        <h2 class="text-white">Testimonials</h2>
    </div>
    <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="10000"
      controls
      indicators
      background="rgba(255,255,255)"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >   
    
        <div
            v-for="(testimonial, index) in testimonials" 
            :key="`testimonial_${index}`" class="position-relative">
            <b-carousel-slide :testimonial="`testimonial_${index}`" class="position-relative">
                <div class="d-flex flex-column testimonial-container">
                    <div class="d-flex flex-grow-1 align-items-center">
                        <div class="d-flex flex-grow-1 testimonial-text-container">
                            <font-awesome-icon :icon="['fas', 'quote-left']"/>
                            <div v-html="testimonial.text" class="flex-grow-1 testimonial-text"></div>
                            <font-awesome-icon :icon="['fas', 'quote-right']"/>
                        </div>
                    </div>
                    <b-row class="position-relative flex-nowrap justify-content-between">
                        <b-col cols="*" class="d-flex justify-content-start align-items-end mb-3">
                            <a
                                class="read-more-btn"
                                href="/testimonials">
                                Read more
                            </a>
                        </b-col>
                        <b-col cols="*" class="d-flex flex-column align-items-end"> 
                            <p class="blockquote-footer testimonial-person"  >
                                {{ testimonial.person }}
                            </p> 
                            <p v-if="testimonial.cite">
                                <cite 
                                    title="Testimonials from our partners"
                                    class="blockquote-footer">
                                    {{ testimonial.cite }}
                                </cite> 
                            </p>
                        </b-col>
                    </b-row>
        
                </div>

            </b-carousel-slide>
        </div>
    </b-carousel> 
  </div>
</template>

<script>
  export default {
    data: () => ({
        slide: 0,
        sliding: null,
        testimonials: [
            {
                text: "Next Gen Math has been a game-changer for our school. In the first full year, we saw 10% SBAC math growth and our 5th grade students cut their distance from standard in half. We expect to see more SBAC growth this year...I recommend it to any principal looking to improve math outcomes.",
                person: "Keri Porter, Principal",
                cite: "Bonita Street STEAM Academy (LAUSD, CA)"
            },
            {
                text: "The genius behind Next Gen is that we had immediate data. We didn't have to wait for common assessments, benchmarks or the end of the year. We had the immediate data, so if students were not mastering the grade level standards, we were able to pull them out of class, send them to work with an interventionist at that time, and master the grade level standards.",
                person: "Patrick Sullivan, Director of Special Projects",
                cite: "Compton Unified School District (CA)"
            },
            {
                text: "Next Gen Math! YOU did it again! These are amazing and will really help students continue to achieve in math at home! YOU Rock!",
                person: "Michele Dawson, Senior Director",
                cite: "Instructional Tech and Innovation for Compton Unified School District"
            },
            {
                text: "The home lessons save me a lot of time, and I love the focus on the major standards!",
                person: "Joyce Nishikawa, 4th Grade Teacher",
                cite: "Inglewood Elementary"
            },
            {
                text: "If you really think about it, most teachers are constantly looking for resources, but they can't find very well-aligned resources. One of the things that we focus on is that alignment between curriculum, instruction, and assessment, and Next Gen Math does a wonderful job of doing that for teachers....Next Gen Math has [also] done an excellent job of aligning the academic vocabulary necessary for students to do well. And the gains that Compton Unified School District has made over the years have proven that.",
                person: "Supt. Dr. Darin Brawley",
                cite: "Instructional Tech and Innovation for Compton Unified School District"
            },
            {
                text: "This is my second year using the NextGenMath platform for math intervention. The platform is easy for students to navigate, and students are able to immediately view results after each completed lesson. My favorite feature is the ability for students to view videos for problems they've missed and do additional practice problems. Lessons are aligned with CCSS for math, creating lessons is simple, and takes minimal time. The new Blended Learning/Individual learning feature is great to use for differentiation during distance learning.",
                person: "Teacher",
                cite: ""
            },
            {
                text: "I use Next Gen Math when my teacher gives us an assignment on it, or when I need more practice with math. I like it because it is very helpful, it helps me understand problems in a clearer way. I like how it gives us our results after we submit it and how it has a video showing us how to solve what we don't understand. I also like how it gives us problems that we could easily access, so we could practice a standard until we get it.",
                person: "D.C., 8th Grade Student",
                cite: ""
            },
            {
                text: "I use NextGenMath.com to provide additional practice on skills that students are struggling with. I really like the video feature as well as unlimited question options!",
                person: "Teacher",
                cite: ""
            },
            {
                text: "As a techie and a supporter of quality education for every student, everywhere...Next Gen Math's tools blow my mind!",
                person: "A.C., Teacher",
                cite: ""
            },
            {
                text: "I enjoy the ability to create standards-based assignments and assessments. They are super easy to make and assign. The data from student scores are broken down into the standards, so it is easy to identify which students need help and in which specific area.",
                person: "Teacher",
                cite: "Los Angeles Unified School District"
            },
            {
                text: "I love that Next Gen Math provides students with immediate feedback based on their answers. I also appreciate the videos that are provided to help students understand how to complete specific problems.",
                person: "Teacher",
                cite: ""
            },
            {
                text: "I like the videos Next Gen Math has available for us, and if you get a question wrong you can go on practice questions. Practice and you'll see you will get it right next time. My teacher gives us quizzes on Next Gen Math or for homework, too. I like that I can see my results when I submit my assignment, and I can practice any math I don't understand.",
                person: "F.S., 8th Grade Student",
                cite: ""
            },
        ],
    }),
    methods: {
      onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
      }
    }
  }
</script>

<style lang="scss" scoped>
    #testimonials-title {
        width: 100%;
        text-align: center;
    }

    .carousel {
        width: 100%;
        border-radius: 12px;
        // top: 10vh;

        &::v-deep .carousel-control-prev-icon {
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23000' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e");
        }
        &::v-deep .carousel-control-next-icon {
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23000' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e");
        }
        &::v-deep .carousel-indicators li {
            background-color: #000;
        }   

        .carousel-item {
            border-radius: 12px;
            &::v-deep .carousel-caption {
                position: relative !important;
                width: 75%;
                height: 100%;
                padding-top: 4rem;
                color: #000;
                margin: 0 auto;
                left: 0;
                right: 0;
 
                .testimonial-container {
                    

                    .testimonial-person {
                        color: #000;
                    }

                    .testimonial-text-container {
                        padding-bottom: 30px;
                        gap: 24px;

                        .testimonial-text {
                            -webkit-box-orient: vertical;
                            display: -webkit-box;
                            overflow: hidden !important;
                            text-overflow: ellipsis;
                            text-overflow: ellipsis;
                        }
                    }

                    cite {
                        text-indent: 2rem;
                        text-align: right;
                        &.blockquote-footer::before {
                            content: "";
                        }
                    }

                    .read-more-btn {
                        text-wrap: nowrap;
                    }
                }
            }
        }
    }

    @media (min-width: 1500px) {
        .testimonial-container {
            height: 16rem;
            max-height: 16rem;

            .testimonial-text {
                font-size: 24px;
                -webkit-line-clamp: 5;
            }

            .testimonial-person {
                font-size: 20px;
            }
            
            .read-more-btn {
                font-size: 18px;
            }
        }
    }

    @media (max-width: 1500px) {
        .testimonial-container {
            height: 12rem;
            max-height: 12rem;

            .testimonial-text {
                font-size: 18px;
                -webkit-line-clamp: 3;
            }

            .testimonial-person {
                font-size: 14px;
            }
            
            .read-more-btn {
                font-size: 12px;
            }

            cite {
                &.blockquote-footer {
                    font-size: 12px;
                }
            }
        }
    }

    @media (max-width: 1024px) {
        .testimonial-container {
            .testimonial-text {
                font-size: 14px;
            }

            .testimonial-person {
                font-size: 12px;
            }
            
            .read-more-btn {
                font-size: 10px;
            }

            cite {
                &.blockquote-footer {
                    font-size: 10px;
                }
            }
        }
    }

    @media (max-width: 768px) {
        .testimonial-container {
            height: 8rem;
            max-height: 8rem;

            .testimonial-text {
                font-size: 12px;
                -webkit-line-clamp: 3;
            }

            .testimonial-person {
                font-size: 10px;
            }
            
            .read-more-btn {
                font-size: 8px;
            }

            cite {
                &.blockquote-footer {
                    font-size: 8px;
                }
            }
        }
    }

    @media (max-width: 576px) {
        .testimonial-container {
            height: 9rem;
            max-height: 9rem;
        }
    }

</style>
